import { Car, Bus, Accessibility, CloudSun, MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

const FALLS = "https://images.unsplash.com/photo-1674852575286-f14dcea428af?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1600";

const INFO = [
  [MapPin, "Getting here", "About 90 minutes from Toronto via the QEW, and 30 minutes from Buffalo via the Rainbow Bridge."],
  [Car, "Parking", "Several paid parking garages are within walking distance in the Fallsview district. Arrive early on show nights."],
  [Bus, "Transit", "The WEGO visitor bus connects hotels, Clifton Hill and Fallsview. Rideshare drop-off near the venue entrance."],
  [Accessibility, "Accessibility", "Accessible viewing areas, companion seating and step-free routes. Contact us ahead to arrange support."],
  [CloudSun, "Rain or shine", "Shows go ahead in light rain. Dress for the weather — umbrellas that block views aren't permitted."],
];

export const Venue = () => (
  <section id="venue" data-testid="venue-info-section" className="relative overflow-hidden py-20 lg:py-32">
    <div className="absolute inset-0">
      <img src={FALLS} alt="" className="h-full w-full object-cover opacity-50" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0C10] via-[#0B0C10]/70 to-[#0B0C10]" />
    </div>
    <div className="relative mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:px-12">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Venue & Visitor Info</Eyebrow>
        <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.9] text-white sm:text-6xl">In the heart of <span className="text-gradient">Fallsview.</span></h2>
        <p className="mt-6 text-zinc-300 md:text-lg">The outdoor stage sits in the Fallsview entertainment district of Niagara Falls, Ontario — surrounded by hotels, restaurants and nightlife, a short walk from the Falls themselves.</p>
        <p className="mt-4 rounded-2xl border border-white/10 bg-black/30 p-4 font-mono text-xs uppercase tracking-wider text-zinc-300">Exact venue address to be confirmed. Details shown are samples.</p>
      </Reveal>
      <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
        {INFO.map(([Icon, title, text], i) => (
          <Reveal key={title} delay={i * 0.06} className={`rounded-[22px] border border-white/10 bg-[#12141C]/80 p-6 backdrop-blur-md ${i === 0 ? "sm:col-span-2" : ""}`}>
            <Icon size={22} className="text-[#C9A0F0]" />
            <p className="mt-4 font-display text-xl font-bold uppercase text-white">{title}</p>
            <p className="mt-1 text-sm text-zinc-300">{text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
